module.exports = __webpack_public_path__ + "static/media/terms.c05283c8.svg";